import { useEffect, useState } from "react";

import useSubscription from "../../../hooks/useSubscription.js";

import expenseService from "../services/expenseService";
// فرض بر این است که این متد را اضافه می‌کنی:
// expenseService.getAttachmentSummary()

const useExpenseLimits = (user) => {

    const subscription = useSubscription(user);

    const [loading, setLoading] = useState(true);

    const [attachmentCount, setAttachmentCount] = useState(0);

    const [error, setError] = useState(null);

    useEffect(() => {

        let mounted = true;

        const load = async () => {

            try {

                setLoading(true);

                const result =
                    await expenseService.getgetAttachmentSummary();

                if (!mounted) return;

                setAttachmentCount(
                    result ?? 0
                );

            } catch (err) {

                if (!mounted) return;

                setError(err);

            } finally {

                if (mounted) {

                    setLoading(false);

                }

            }

        };

        load();

        return () => {

            mounted = false;

        };

    }, []);

    return {

        loading,

        error,

        attachmentCount,

        canAttach:

            subscription.canUse(

                "attachments",

                attachmentCount

            ),

        remainingAttachments:

            subscription.remaining(

                "attachments",

                attachmentCount

            ),

    };

};

export default useExpenseLimits;